<template>
    <div class="home_body">
        <div class="container__home">
            <template v-if="courseFinished" >
                <div class="container__home__alert">
                    <i class="material-icons-outlined">school</i>
                    <div class="container__home__alert__text">
                        <strong>¡Felicitaciones! Has completado todas las unidades.</strong>
                        <span>Recuerda que puedes seguir accediendo a los materiales del curso todas las veces que necesites</span>
                    </div>
                </div>

                <button class="container__home__button" @click="downloadCertificate" :disabled="processingCertificateDownload">{{ processingCertificateDownload  ? $t('login.actions.PROCESSING') :'Descargar certificado' }}</button>
            </template>
            <div class="container__home__iframe">
                <iframe id="ifrmScormCourse" src="" frameborder="0"></iframe> 
            </div>
        </div>

        <Modal v-if="activeModalCertificate" :isOpen="activeModalCertificate" @close="activeModalCertificate = false">
            <div class="modal__certificate">
                <h3>Antes de finalizar ...</h3>
                <span>Por favor completa los siguientes datos para descargar tu certificado:</span>

                <div class="modal__certificate__form">
                    <div class="input" :class="{'invalid-field': v$.dataModel.Documento.$invalid && submitted}">
                        <label for="doc">Número de documento</label>
                        <input type="text" id="doc" v-model="dataModel.Documento">
                    </div>
                    <div class="input" :class="{'invalid-field': v$.dataModel.NivelDeEstudioId.$invalid && submitted}">
                        <select v-model="dataModel.NivelDeEstudioId">
                            <option value="">Nivel de estudio</option>
                            <option v-for="(nivel, index) in nivelesDeEstudio" :key="index" :value="nivel.Id">{{nivel.Nombre}}</option>
                        </select>
                    </div>
                    <div class="input" :class="{'invalid-field': v$.dataModel.SituacionLaboralId.$invalid && submitted}">
                        <select v-model="dataModel.SituacionLaboralId">
                            <option value="">Situación laboral</option>
                            <option v-for="(situacion, index) in situacionesLaborales" :key="index" :value="situacion.Id">{{situacion.Nombre}}</option>
                        </select>
                    </div>
                </div>

                <div class="modal__certificate__buttons">
                    <button class="next" @click="saveCertificateData">Confirmar <i class="material-icons">east</i></button>
                </div>
            </div>
        </Modal>

    </div>
</template>
<script>
import Modal from '@/components/Modal.vue';
import { computed, ref, onMounted, onBeforeUnmount } from 'vue-demi'; 
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { useStore } from 'vuex';

export default {
    components: {
        Modal
    },
    setup() {
        const v$ = useVuelidate();
        const store = useStore();
        const activeModalCertificate = ref(false);
        const submitted = ref(false);
        const courseFinished = ref(false);
        const processingCertificateDownload = ref(false);
        const user = computed(() => store.getters.manageUser_user);
        const dataModel = ref({
            Documento: '',
            NivelDeEstudioId: '',
            SituacionLaboralId: ''
        });
        const nivelesDeEstudio = ref([])
        const situacionesLaborales = ref([])

        const courseProgressRAW = ref(null);

/*
        onMounted(async () => {
            window.API_1484_11  = new window.Scorm2004API({});
            
            window.API_1484_11.student_id = user.value.id;
            window.API_1484_11.student_name = `${user.value.Nombre} ${user.value.Apellido}`;
            console.log("USER",user.value);
            try
            {
                const request = await store.dispatch('course_progress_get');
                if (request.status === 200) {
                    courseProgressRAW.value = JSON.parse(request.data.courseProgress)
                    //courseProgressRAW.value = JSON.parse('{"suspend_data":"2cY~2k160708090a0b0n1o1i0j0k0l0m0n0o0p0q0r0s0t0u0v0w0x0y0A0B0c0p1D0E0F0r1c1d1e1f1g1h1i1j1k1~2e4~2a4100181a~2$30101201112012120131201412015120101b015120101b015120101c015120101301113012130131301413015130161301713018130191301a1301b1301c1301d1301e13015120101401114013140141401512016120101d01612010150111501215016120101f016120101a0111a0121a0131a0141a0151a0161a0171a0181a~2P1s000000000000000000000000000010111010101011111111111111101010131010101010101010v_player.5gCY5icAhEM.5XYi9b05Y5j1^1^00~2D9~2s493SW6411103Mt1~2Y334003400d70030102202203400r7a000121^h_default_Disabledg620101^8_defaultr7a000121^h_default_Disabledr7a000121^h_default_Disabled34203420b72000101^11b72010101111b72010101111b72030101111b72010101111b72030101111b72030101111b72030101111g600101^8_default340002148101010100~215932f4411103Mt1~2x434003400d70040102252253400r78000121^h_default_Disabledg600101^8_defaultr78000121^h_default_Disabledr78000121^h_default_Disabledb70010101111b70010101111b70010101111g600101^8_defaultb70030101111b70030101111b70030101111q70010111^g_default_Visitedg600101^8_defaultg600101^8_default3420342034000214810101010000~28g~2h5936I3411103Mt1~2R434003400d70010102102103400g600101^8_defaultg600101^8_defaultg600101^8_defaultr7a000121^h_default_Disabled34203000g640101^8_default300030003000300034203420q72010111^g_default_Visited5540003440344034403440q72010111^g_default_Visited5540003440344034403440q72010111^g_default_Visited5540003440344034403440344034400210410150~2p693sI4411103Mt1~2$534003400d70010102102103400g600101^8_defaultg600101^8_defaultr78000121^h_default_Disabledg620101^8_default34203000g640101^8_default300030003000300034203420q70010121^g_default_Visited554000344034403440q72010121^g_default_Visited554000344034403440q72010121^g_default_Visited554000344034403440q72010121^g_default_Visited554000344034403440q72010121^g_default_Visited554000344034403440344002102150~2X3b3o3661210123Mt1~2n334003400d70020102152153400g600101^8_defaultg600101^8_defaultg600101^8_defaultr7a000121^h_default_Disabled34203000g640101^8_default30003000300030003420g620101^8_defaultg620101^8_defaultq72000111^g_default_Visited34400210a10101010150ml3R7241110b101001a1a10~2E2~2A2j3gt4210b101021010113vk4~2223400d70020102152153400340034003000g620101^8_defaultg680101^8_defaultr78000121^h_default_Selectedg680101^8_defaultg680101^8_default02100000000~2Qn~2Z393e844111038e1~2B334003400d70050102302303400g620101^8_defaultg620101^8_defaultg620101^8_defaultr78000121^h_default_Disabledq72000121^g_default_Visitedq72000121^g_default_Visitedq72000121^g_default_Visitedq72000121^g_default_Visited3440342034203420002150~2Z393kW34111038e1~2B334003400d70050102302303400g620101^8_defaultg620101^8_defaultg620101^8_defaultr78000121^h_default_Disabledq72000121^g_default_Visitedq72000121^g_default_Visitedq72000121^g_default_Visitedq72000121^g_default_Visited3420342034203440002150~2R7l33nf41110b3010210101238e1~2f734003400d70050102302303400g620101^8_defaultg620101^8_defaultr7a000121^h_default_Disabledr7a000121^h_default_Disabledg620101^8_default342034203000g640101^8_default300030003000300034203420g6a0101^8_default3440344030003000g6a0101^8_default3440344030003000r7a010121^h_default_Selected554000344034403040g6a0101^8_default3440344030003040g6a0101^8_default3440344030403040g6a0101^8_default3440344030403040g6a0101^8_default3440344030003000g6a0101^8_default344034403000304002102150~2P7j3Eo1210b301021010103461~2f734003400d70050102302303400g620101^8_defaultg620101^8_defaultr7a000121^h_default_Disabledr7a000121^h_default_Disabledg620101^8_default342034003000g640101^8_default300030003000300034003420r7a010121^h_default_Selected554000344034403040g6a0101^8_default3440344030003000g6a0101^8_default3440344030003040g6a0101^8_default3440344030003040g6a0101^8_default3440344030003000g6a0101^8_default3440344030003040g6a0101^8_default3440344030003000g6a0101^8_default34403440300030000210215000000000000","launch_data":"","comments":"","comments_from_lms":"","core":{"student_id":"","student_name":"","lesson_location":"","credit":"","lesson_status":"incomplete","entry":"","lesson_mode":"normal","exit":"suspend","session_time":"0000:13:44.10","score":{"raw":"","min":"","max":"100"}},"objectives":{},"student_data":{"mastery_score":"","max_time_allowed":"","time_limit_action":""},"student_preference":{"audio":"","language":"","speed":"","text":""},"interactions":{}}');


                    if(request.data.courseProgress != null)
                    {
                        if(courseProgressRAW.value != null && request.data.lessonStatus == 'completed')
                            courseFinished.value = true
                        window.API_1484_11.loadFromJSON(JSON.parse(request.data.courseProgress))
                        //window.API_1484_11.loadFromJSON(JSON.parse('{"suspend_data":"2cY~2k160708090a0b0n1o1i0j0k0l0m0n0o0p0q0r0s0t0u0v0w0x0y0A0B0c0p1D0E0F0r1c1d1e1f1g1h1i1j1k1~2e4~2a4100181a~2$30101201112012120131201412015120101b015120101b015120101c015120101301113012130131301413015130161301713018130191301a1301b1301c1301d1301e13015120101401114013140141401512016120101d01612010150111501215016120101f016120101a0111a0121a0131a0141a0151a0161a0171a0181a~2P1s000000000000000000000000000010111010101011111111111111101010131010101010101010v_player.5gCY5icAhEM.5XYi9b05Y5j1^1^00~2D9~2s493SW6411103Mt1~2Y334003400d70030102202203400r7a000121^h_default_Disabledg620101^8_defaultr7a000121^h_default_Disabledr7a000121^h_default_Disabled34203420b72000101^11b72010101111b72010101111b72030101111b72010101111b72030101111b72030101111b72030101111g600101^8_default340002148101010100~215932f4411103Mt1~2x434003400d70040102252253400r78000121^h_default_Disabledg600101^8_defaultr78000121^h_default_Disabledr78000121^h_default_Disabledb70010101111b70010101111b70010101111g600101^8_defaultb70030101111b70030101111b70030101111q70010111^g_default_Visitedg600101^8_defaultg600101^8_default3420342034000214810101010000~28g~2h5936I3411103Mt1~2R434003400d70010102102103400g600101^8_defaultg600101^8_defaultg600101^8_defaultr7a000121^h_default_Disabled34203000g640101^8_default300030003000300034203420q72010111^g_default_Visited5540003440344034403440q72010111^g_default_Visited5540003440344034403440q72010111^g_default_Visited5540003440344034403440344034400210410150~2p693sI4411103Mt1~2$534003400d70010102102103400g600101^8_defaultg600101^8_defaultr78000121^h_default_Disabledg620101^8_default34203000g640101^8_default300030003000300034203420q70010121^g_default_Visited554000344034403440q72010121^g_default_Visited554000344034403440q72010121^g_default_Visited554000344034403440q72010121^g_default_Visited554000344034403440q72010121^g_default_Visited554000344034403440344002102150~2X3b3o3661210123Mt1~2n334003400d70020102152153400g600101^8_defaultg600101^8_defaultg600101^8_defaultr7a000121^h_default_Disabled34203000g640101^8_default30003000300030003420g620101^8_defaultg620101^8_defaultq72000111^g_default_Visited34400210a10101010150ml3R7241110b101001a1a10~2E2~2A2j3gt4210b101021010113vk4~2223400d70020102152153400340034003000g620101^8_defaultg680101^8_defaultr78000121^h_default_Selectedg680101^8_defaultg680101^8_default02100000000~2Qn~2Z393e844111038e1~2B334003400d70050102302303400g620101^8_defaultg620101^8_defaultg620101^8_defaultr78000121^h_default_Disabledq72000121^g_default_Visitedq72000121^g_default_Visitedq72000121^g_default_Visitedq72000121^g_default_Visited3440342034203420002150~2Z393kW34111038e1~2B334003400d70050102302303400g620101^8_defaultg620101^8_defaultg620101^8_defaultr78000121^h_default_Disabledq72000121^g_default_Visitedq72000121^g_default_Visitedq72000121^g_default_Visitedq72000121^g_default_Visited3420342034203440002150~2R7l33nf41110b3010210101238e1~2f734003400d70050102302303400g620101^8_defaultg620101^8_defaultr7a000121^h_default_Disabledr7a000121^h_default_Disabledg620101^8_default342034203000g640101^8_default300030003000300034203420g6a0101^8_default3440344030003000g6a0101^8_default3440344030003000r7a010121^h_default_Selected554000344034403040g6a0101^8_default3440344030003040g6a0101^8_default3440344030403040g6a0101^8_default3440344030403040g6a0101^8_default3440344030003000g6a0101^8_default344034403000304002102150~2P7j3Eo1210b301021010103461~2f734003400d70050102302303400g620101^8_defaultg620101^8_defaultr7a000121^h_default_Disabledr7a000121^h_default_Disabledg620101^8_default342034003000g640101^8_default300030003000300034003420r7a010121^h_default_Selected554000344034403040g6a0101^8_default3440344030003000g6a0101^8_default3440344030003040g6a0101^8_default3440344030003040g6a0101^8_default3440344030003000g6a0101^8_default3440344030003040g6a0101^8_default3440344030003000g6a0101^8_default34403440300030000210215000000000000","launch_data":"","comments":"","comments_from_lms":"","core":{"student_id":"","student_name":"","lesson_location":"","credit":"","lesson_status":"incomplete","entry":"","lesson_mode":"normal","exit":"suspend","session_time":"0000:13:44.10","score":{"raw":"","min":"","max":"100"}},"objectives":{},"student_data":{"mastery_score":"","max_time_allowed":"","time_limit_action":""},"student_preference":{"audio":"","language":"","speed":"","text":""},"interactions":{}}'))
                    }
                }
            }
            catch (ex)
            {
                if(JSON.parse(ex.request.response).Message == "COURSE_PROGRESS_NOT_FOUND")
                {
                    activeModalCertificate.value = false;
                }
            }
            window.API_1484_11.student_id = user.value.id;
            window.API_1484_11.student_name = `${user.value.Nombre} ${user.value.Apellido}`;
            window.API_1484_11.on("SetValue", onLMSSetValue);
            window.API_1484_11.on("GetValue", onLMSGetValue);
            window.API_1484_11.on("Finish", onLMSFinish);
            window.API_1484_11.on("Initialize", function() {
                console.log("Initialize")
            })
window.API_1484_11.clear("Initialize");

            window.API_1484_11.on("GetLastError", async (a) => { console.log("LMSGetLastError",a); } );
            window.API_1484_11.on("GetErrorString", async (a) => { console.log("LMSGetErrorString",a); } );
            window.API_1484_11.on("GetDiagnostic", async (a) => { console.log("LMSGetDiagnostic",a); } );


            document.getElementById("ifrmScormCourse").setAttribute("src","/scorm-course/index.html")
            const res = await store.dispatch('inscription_getOptions');
            nivelesDeEstudio.value = res.data.nivelesDeEstudio;
            situacionesLaborales.value = res.data.situacionLaboral
            //setTimeout(() => ,500) 
        });
*/

        onMounted(async () => {
            window.API = new window.Scorm12API({});
            window.API.student_id = user.value.id;
            window.API.student_name = `${user.value.Nombre} ${user.value.Apellido}`;
            try
            {
                const request = await store.dispatch('course_progress_get');
                if (request.status === 200) {
                    courseProgressRAW.value = JSON.parse(request.data.courseProgress)
                    //courseProgressRAW.value = JSON.parse('{"suspend_data":"2cY~2k160708090a0b0n1o1i0j0k0l0m0n0o0p0q0r0s0t0u0v0w0x0y0A0B0c0p1D0E0F0r1c1d1e1f1g1h1i1j1k1~2e4~2a4100181a~2$30101201112012120131201412015120101b015120101b015120101c015120101301113012130131301413015130161301713018130191301a1301b1301c1301d1301e13015120101401114013140141401512016120101d01612010150111501215016120101f016120101a0111a0121a0131a0141a0151a0161a0171a0181a~2P1s000000000000000000000000000010111010101011111111111111101010131010101010101010v_player.5gCY5icAhEM.5XYi9b05Y5j1^1^00~2D9~2s493SW6411103Mt1~2Y334003400d70030102202203400r7a000121^h_default_Disabledg620101^8_defaultr7a000121^h_default_Disabledr7a000121^h_default_Disabled34203420b72000101^11b72010101111b72010101111b72030101111b72010101111b72030101111b72030101111b72030101111g600101^8_default340002148101010100~215932f4411103Mt1~2x434003400d70040102252253400r78000121^h_default_Disabledg600101^8_defaultr78000121^h_default_Disabledr78000121^h_default_Disabledb70010101111b70010101111b70010101111g600101^8_defaultb70030101111b70030101111b70030101111q70010111^g_default_Visitedg600101^8_defaultg600101^8_default3420342034000214810101010000~28g~2h5936I3411103Mt1~2R434003400d70010102102103400g600101^8_defaultg600101^8_defaultg600101^8_defaultr7a000121^h_default_Disabled34203000g640101^8_default300030003000300034203420q72010111^g_default_Visited5540003440344034403440q72010111^g_default_Visited5540003440344034403440q72010111^g_default_Visited5540003440344034403440344034400210410150~2p693sI4411103Mt1~2$534003400d70010102102103400g600101^8_defaultg600101^8_defaultr78000121^h_default_Disabledg620101^8_default34203000g640101^8_default300030003000300034203420q70010121^g_default_Visited554000344034403440q72010121^g_default_Visited554000344034403440q72010121^g_default_Visited554000344034403440q72010121^g_default_Visited554000344034403440q72010121^g_default_Visited554000344034403440344002102150~2X3b3o3661210123Mt1~2n334003400d70020102152153400g600101^8_defaultg600101^8_defaultg600101^8_defaultr7a000121^h_default_Disabled34203000g640101^8_default30003000300030003420g620101^8_defaultg620101^8_defaultq72000111^g_default_Visited34400210a10101010150ml3R7241110b101001a1a10~2E2~2A2j3gt4210b101021010113vk4~2223400d70020102152153400340034003000g620101^8_defaultg680101^8_defaultr78000121^h_default_Selectedg680101^8_defaultg680101^8_default02100000000~2Qn~2Z393e844111038e1~2B334003400d70050102302303400g620101^8_defaultg620101^8_defaultg620101^8_defaultr78000121^h_default_Disabledq72000121^g_default_Visitedq72000121^g_default_Visitedq72000121^g_default_Visitedq72000121^g_default_Visited3440342034203420002150~2Z393kW34111038e1~2B334003400d70050102302303400g620101^8_defaultg620101^8_defaultg620101^8_defaultr78000121^h_default_Disabledq72000121^g_default_Visitedq72000121^g_default_Visitedq72000121^g_default_Visitedq72000121^g_default_Visited3420342034203440002150~2R7l33nf41110b3010210101238e1~2f734003400d70050102302303400g620101^8_defaultg620101^8_defaultr7a000121^h_default_Disabledr7a000121^h_default_Disabledg620101^8_default342034203000g640101^8_default300030003000300034203420g6a0101^8_default3440344030003000g6a0101^8_default3440344030003000r7a010121^h_default_Selected554000344034403040g6a0101^8_default3440344030003040g6a0101^8_default3440344030403040g6a0101^8_default3440344030403040g6a0101^8_default3440344030003000g6a0101^8_default344034403000304002102150~2P7j3Eo1210b301021010103461~2f734003400d70050102302303400g620101^8_defaultg620101^8_defaultr7a000121^h_default_Disabledr7a000121^h_default_Disabledg620101^8_default342034003000g640101^8_default300030003000300034003420r7a010121^h_default_Selected554000344034403040g6a0101^8_default3440344030003000g6a0101^8_default3440344030003040g6a0101^8_default3440344030003040g6a0101^8_default3440344030003000g6a0101^8_default3440344030003040g6a0101^8_default3440344030003000g6a0101^8_default34403440300030000210215000000000000","launch_data":"","comments":"","comments_from_lms":"","core":{"student_id":"","student_name":"","lesson_location":"","credit":"","lesson_status":"incomplete","entry":"","lesson_mode":"normal","exit":"suspend","session_time":"0000:13:44.10","score":{"raw":"","min":"","max":"100"}},"objectives":{},"student_data":{"mastery_score":"","max_time_allowed":"","time_limit_action":""},"student_preference":{"audio":"","language":"","speed":"","text":""},"interactions":{}}');


                    if(request.data.courseProgress != null)
                    {
                        if(courseProgressRAW.value != null && request.data.lessonStatus == 'completed')
                            courseFinished.value = true
                        window.API.loadFromJSON(JSON.parse(request.data.courseProgress))
                        //window.API.loadFromJSON(JSON.parse('{"suspend_data":"2cY~2k160708090a0b0n1o1i0j0k0l0m0n0o0p0q0r0s0t0u0v0w0x0y0A0B0c0p1D0E0F0r1c1d1e1f1g1h1i1j1k1~2e4~2a4100181a~2$30101201112012120131201412015120101b015120101b015120101c015120101301113012130131301413015130161301713018130191301a1301b1301c1301d1301e13015120101401114013140141401512016120101d01612010150111501215016120101f016120101a0111a0121a0131a0141a0151a0161a0171a0181a~2P1s000000000000000000000000000010111010101011111111111111101010131010101010101010v_player.5gCY5icAhEM.5XYi9b05Y5j1^1^00~2D9~2s493SW6411103Mt1~2Y334003400d70030102202203400r7a000121^h_default_Disabledg620101^8_defaultr7a000121^h_default_Disabledr7a000121^h_default_Disabled34203420b72000101^11b72010101111b72010101111b72030101111b72010101111b72030101111b72030101111b72030101111g600101^8_default340002148101010100~215932f4411103Mt1~2x434003400d70040102252253400r78000121^h_default_Disabledg600101^8_defaultr78000121^h_default_Disabledr78000121^h_default_Disabledb70010101111b70010101111b70010101111g600101^8_defaultb70030101111b70030101111b70030101111q70010111^g_default_Visitedg600101^8_defaultg600101^8_default3420342034000214810101010000~28g~2h5936I3411103Mt1~2R434003400d70010102102103400g600101^8_defaultg600101^8_defaultg600101^8_defaultr7a000121^h_default_Disabled34203000g640101^8_default300030003000300034203420q72010111^g_default_Visited5540003440344034403440q72010111^g_default_Visited5540003440344034403440q72010111^g_default_Visited5540003440344034403440344034400210410150~2p693sI4411103Mt1~2$534003400d70010102102103400g600101^8_defaultg600101^8_defaultr78000121^h_default_Disabledg620101^8_default34203000g640101^8_default300030003000300034203420q70010121^g_default_Visited554000344034403440q72010121^g_default_Visited554000344034403440q72010121^g_default_Visited554000344034403440q72010121^g_default_Visited554000344034403440q72010121^g_default_Visited554000344034403440344002102150~2X3b3o3661210123Mt1~2n334003400d70020102152153400g600101^8_defaultg600101^8_defaultg600101^8_defaultr7a000121^h_default_Disabled34203000g640101^8_default30003000300030003420g620101^8_defaultg620101^8_defaultq72000111^g_default_Visited34400210a10101010150ml3R7241110b101001a1a10~2E2~2A2j3gt4210b101021010113vk4~2223400d70020102152153400340034003000g620101^8_defaultg680101^8_defaultr78000121^h_default_Selectedg680101^8_defaultg680101^8_default02100000000~2Qn~2Z393e844111038e1~2B334003400d70050102302303400g620101^8_defaultg620101^8_defaultg620101^8_defaultr78000121^h_default_Disabledq72000121^g_default_Visitedq72000121^g_default_Visitedq72000121^g_default_Visitedq72000121^g_default_Visited3440342034203420002150~2Z393kW34111038e1~2B334003400d70050102302303400g620101^8_defaultg620101^8_defaultg620101^8_defaultr78000121^h_default_Disabledq72000121^g_default_Visitedq72000121^g_default_Visitedq72000121^g_default_Visitedq72000121^g_default_Visited3420342034203440002150~2R7l33nf41110b3010210101238e1~2f734003400d70050102302303400g620101^8_defaultg620101^8_defaultr7a000121^h_default_Disabledr7a000121^h_default_Disabledg620101^8_default342034203000g640101^8_default300030003000300034203420g6a0101^8_default3440344030003000g6a0101^8_default3440344030003000r7a010121^h_default_Selected554000344034403040g6a0101^8_default3440344030003040g6a0101^8_default3440344030403040g6a0101^8_default3440344030403040g6a0101^8_default3440344030003000g6a0101^8_default344034403000304002102150~2P7j3Eo1210b301021010103461~2f734003400d70050102302303400g620101^8_defaultg620101^8_defaultr7a000121^h_default_Disabledr7a000121^h_default_Disabledg620101^8_default342034003000g640101^8_default300030003000300034003420r7a010121^h_default_Selected554000344034403040g6a0101^8_default3440344030003000g6a0101^8_default3440344030003040g6a0101^8_default3440344030003040g6a0101^8_default3440344030003000g6a0101^8_default3440344030003040g6a0101^8_default3440344030003000g6a0101^8_default34403440300030000210215000000000000","launch_data":"","comments":"","comments_from_lms":"","core":{"student_id":"","student_name":"","lesson_location":"","credit":"","lesson_status":"incomplete","entry":"","lesson_mode":"normal","exit":"suspend","session_time":"0000:13:44.10","score":{"raw":"","min":"","max":"100"}},"objectives":{},"student_data":{"mastery_score":"","max_time_allowed":"","time_limit_action":""},"student_preference":{"audio":"","language":"","speed":"","text":""},"interactions":{}}'))
                    }
                }
            }
            catch (ex)
            {
                if(JSON.parse(ex.request.response).Message == "COURSE_PROGRESS_NOT_FOUND")
                {
                    activeModalCertificate.value = false;
                }
            }
            window.API.on("LMSSetValue", onLMSSetValue);
            window.API.on("LMSGetValue", onLMSGetValue);
            window.API.on("LMSFinish", onLMSFinish);


            window.API.on("LMSGetLastError", async (a) => { console.log("LMSGetLastError",a); } );
            window.API.on("LMSGetErrorString", async (a) => { console.log("LMSGetErrorString",a); } );
            window.API.on("LMSGetDiagnostic", async (a) => { console.log("LMSGetDiagnostic",a); } );


            document.getElementById("ifrmScormCourse").setAttribute("src","/scorm-course/index.html")
            const res = await store.dispatch('inscription_getOptions');
            nivelesDeEstudio.value = res.data.nivelesDeEstudio;
            situacionesLaborales.value = res.data.situacionLaboral
            //setTimeout(() => ,500) 
        });

        onBeforeUnmount(() => {
            window.API.off("LMSSetValue");
            window.API.off("LMSGetValue");
            window.API.off("LMSFinish");
        });

        
        async function onLMSSetValue() {
            //enviar a guardar
            courseProgressRAW.value = window.API.cmi;
            if(window.API.cmi.core.lesson_status == 'completed')
                courseFinished.value = 1
            

            const model = {
                LessonStatus : window.API.cmi.core.lesson_status,
                ProgressRAW : JSON.stringify(window.API.cmi)
            };
            await store.dispatch('course_progress_save',model);
            console.log(window.API.cmi)
            return true;
        }

        function onLMSGetValue() {
            return window.API.cmi;
        }

        function onLMSFinish() {
            
        }


        async function downloadCertificate()
        {
            processingCertificateDownload.value = true;
            try
            {
                await store.dispatch('course_certificate_download');
                processingCertificateDownload.value = false;
            }
            catch(ex)
            {
                const responseText = await ex.request.response.text();
                if(JSON.parse(responseText).Message == "INCOMPLETE_CERTIFICATE_DATA")
                {
                    activeModalCertificate.value = true;
                }
                processingCertificateDownload.value = false;
            }
        }
    

        async function saveCertificateData(){
            submitted.value = true;
            processingCertificateDownload.value = true;
            if (!v$.value.dataModel.$invalid) {
                try {
                    await store.dispatch('certificate_completeData', dataModel.value);
                    activeModalCertificate.value = false;
                    await downloadCertificate()
                    processingCertificateDownload.value = false;
                } catch (error) {
                    console.log(error);
                    store.dispatch('notifications_create', { text: 'Ocurrió un error, intenta nuevamente' })
                } finally{
                    submitted.value = false;
                    activeModalCertificate.value = false;
                    processingCertificateDownload.value = false;
                }
            }
        }

        return {
            v$,
            activeModalCertificate,
            dataModel,
            courseFinished,
            downloadCertificate,
            nivelesDeEstudio,
            situacionesLaborales,
            saveCertificateData,
            processingCertificateDownload
        }
    },
    validations(){
        return{
            dataModel: {
                Documento : { required },
                NivelDeEstudioId : { required },
                SituacionLaboralId : { required }
            }
        }
    }
}
</script>
<style lang="scss">
@import '@/styles/main.scss';
.home_body {
    height: 100%;
}
#ifrmScormCourse {
    width: 100%;
    height: 100%;
}
.container__home {
    height: 100%;
    width: 100%;
    max-width: 1024px;
    margin: 0 auto;
    padding: 24px 0;
    padding-bottom: 0px;

    &__alert {
        background: #ffe0a6;
        padding: 24px;
        margin: 12px 0;
        display: flex;
        gap: 12px;

        i {
            color: $green;
        }

        &__text {
            display: flex;
            flex-direction: column;
            gap: 8px;
        }
    }

    &__button {
        padding: 12px 24px;
        margin: 12px 0px;
        @include icon-and-text-container;
        justify-content: center;
        border: 1px solid;
        border-radius: 44px;
        color: $green;
        font-weight: 600;
        font-size: 16px;
        @media screen and (max-width: 1024px){
            margin: 12px 12px;
        }
    }
    h1 {
        @media screen and (max-width: 1024px){
            margin-left: 12px;
        }
    }

    &__iframe {
        width: 100%;
        height: calc(100% - 44px);
        background: grey;
        margin: 12px 0;
        max-height: 577px;
        
    }
    @media screen and (max-width: 1024px){
        &__iframe {
            width: 100%;
            height: 100vh;
            background: grey;
            margin: 0px;
            overflow: hidden;
            max-height: unset;
        }
    }
}

.modal__certificate {
    padding: 0 24px;
    display: flex;
    flex-direction: column;
    gap: 12px;

    &__form {
        display: flex;
        flex-direction: column;
        gap: 16px;

        .input {
            height: 50px;
            padding: 0 12px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: #F6F6F6;
            border-radius: 50px;
            border: none;

            label{
                padding-right: 6px;
                background: #F6F6F6;
                font-size: 13px;
                font-weight: 400;
            }
            
            input, select{
                background: #F6F6F6;
                border: none;
                flex-grow: 1;
                font-size: 14px;
            }
        }
    }

    &__buttons {
        margin: 24px 0px;
        
        .next{
            width: 100%;
            padding: 13px 0;
            @include icon-and-text-container;
            justify-content: center;
            background: $green;
            border-radius: 44px;
            color: #fff;
            font-weight: 600;
            font-size: 16px;
            .material-icons{
                color: white;
                font-size: 18px;
            }
        }
    }
}
</style>